import sendRequest from '@/helpers/sendRequest';
import { FILE_INSTANCE } from '@/constants/api';

class AssistantService {
  async sendFileToServer<T extends Object>(
    file?: File,
    url = '/monitoring-api/files/',
    method: 'post' | 'patch' = 'post'
  ): Promise<T | undefined | null> {
    if (!file) return;

    const formData = new FormData();

    formData.append('file', file);
    return await sendRequest<T>({
      url,
      body: formData,
      method,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((res) => res?.data)
      .catch(() => null);
  }

  async getFile(
    url: string,
    fileName: string = 'новый файл.txt'
  ): Promise<{ error: string }> {
    const response = await sendRequest<string>(
      {
        url: url,
        method: 'get',
      },
      FILE_INSTANCE
    )
      .then((res) => res)
      .catch((err) => ({ data: null, error: '' + err }));
    if (!response.data) return response;

    try {
      const binary = atob(response.data.replace(/\s/g, ''));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }

      const blobedFile = await new Blob([view], {
        type: response.headers.contentType,
      });

      const urlFake = window.URL.createObjectURL(blobedFile);
      const link = document.createElement('a');
      link.href = urlFake;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return response;
    } catch (e) {
      return { error: 'error:' + e };
    }
  }

  async getFileById(fileId?: string): Promise<void> {
    if (!fileId) return;

    await sendRequest({
      url: `/monitoring-api/files/${fileId}/`,
      method: 'get',
    });
  }

  async getSignedDocument(reportId: string | number) {
    return await this.getFile(
      `/monitoring-api/reports/${reportId}/signed_document/?encoding=base64`,
      'Отчет_подписанный.pdf'
    );
  }

  async getAnnualReport(pollId?: string) {
    return await this.getFile(
      `/monitoring-api/polls/${pollId}/export/xlsx/?encoding=base64`,
      'Отчет.xlsx'
    );
  }

  async getLocalReport(reportId: number, extension: 'pdf' | 'docx' | 'xlsx') {
    return await this.getFile(
      `/monitoring-api/reports/${reportId}/export/${extension}/?encoding=base64`,
      'Отчет.' + extension
    );
  }
}

const assistantService = new AssistantService();

export { AssistantService, assistantService };
